/**
 * DomainIndexRedirect - Redirects to the first active page in a domain
 * Dynamically determines the first active page based on page_config
 */

import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useBetaMode } from '../layouts/MainLayout';

const DomainIndexRedirect = ({ domainKey, fallbackPath }) => {
  const { betaMode } = useBetaMode();
  const [redirectPath, setRedirectPath] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFirstActivePage = async () => {
      try {
        const response = await fetch(`/api/admin/config/pages?domain_key=${domainKey}`);
        const pages = await response.json();

        // Filter to active pages (or all if beta mode)
        const activePages = pages
          .filter(page => betaMode || !!page.is_active)
          .sort((a, b) => (a.display_order || 0) - (b.display_order || 0));

        if (activePages.length > 0) {
          setRedirectPath(activePages[0].page_path);
        } else {
          // If no active pages, use fallback
          setRedirectPath(fallbackPath);
        }
      } catch (error) {
        console.error('Error loading pages for redirect:', error);
        setRedirectPath(fallbackPath);
      } finally {
        setLoading(false);
      }
    };

    loadFirstActivePage();
  }, [domainKey, betaMode, fallbackPath]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return <Navigate to={redirectPath} replace />;
};

export default DomainIndexRedirect;
